// import React, { useState } from "react";
// import RoleTable from "../../components/Super Admin/Core Functions/RoleTable";
// import SubRoleTable from '../../components/Super Admin/Core Functions/SubRoleTable'
// import "../../css/RolesPage.css";
// import Sidebar from "../../components/Super Admin/SideBar/Sidebar";
// import TopTabs from "../../components/Super Admin/TopBar/TopbarCoreFunctions";

// const RolesPage: React.FC = () => {
//   const [activeTab, setActiveTab] = useState<"role" | "subrole">("role");

//   return (
//     <div className="forms-page">
//         {/* <Sidebar /> */}
//         <div className="main-content">
//             <TopTabs />
//     <div className="roles-page">
//       <div className="top-tab">
//         <button
//           className={activeTab === "role" ? "active" : ""}
//           onClick={() => setActiveTab("role")}
//         >
//           Role
//         </button>
//         <button
//           className={activeTab === "subrole" ? "active" : ""}
//           onClick={() => setActiveTab("subrole")}
//         >
//           Sub-Role
//         </button>
//       </div>

//       <div className="tab-content">
//         {activeTab === "role" ? <RoleTable /> : <SubRoleTable />}
//       </div>
//       </div>
//     </div>
//     </div>
//   );
// };

// export default RolesPage;




import React, { useState } from "react";
import RoleTable from "../../components/Super Admin/Core Functions/RoleTable";
import SubRoleTable from '../../components/Super Admin/Core Functions/SubRoleTable';
import "../../css/RolesPage.css"; // We will update this file next
import TopTabs from "../../components/Super Admin/TopBar/TopbarCoreFunctions";

const RolesPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<"role" | "subrole">("role");

  return (
    // Use a Fragment, not a layout div
    <>
      <TopTabs />
      <div className="roles-page-container"> {/* Renamed from roles-page */}
        <div className="roles-page-tabs"> {/* Renamed from top-tab */}
          <button
            className={activeTab === "role" ? "active" : ""}
            onClick={() => setActiveTab("role")}
          >
            Role
          </button>
          <button
            className={activeTab === "subrole" ? "active" : ""}
            onClick={() => setActiveTab("subrole")}
          >
            Sub-Role
          </button>
        </div>

        <div className="roles-page-tab-content"> {/* Renamed from tab-content */}
          {activeTab === "role" ? <RoleTable /> : <SubRoleTable />}
        </div>
      </div>
    </>
  );
};

export default RolesPage;